<template>
    <div>
        <b-form @submit="onSubmit" v-if="show">
              <b-form-group id="ReminderMailGroup"
                    label=""
                    label-for="reminderMail">
        <b-form-input id="reminderMail"
                      type="email"
                      v-model.trim="form.email"
                      required
                      placeholder="Enter your@email.com">
        </b-form-input>
                    <b-form-text id="reminderMailFeedback">
      <!-- This will only be shown if the preceeding input has an invalid state -->
      Enter your email address, we will send you an email to reset your password. 
    </b-form-text>
         </b-form-group>
        

       <b-button :to="{name:'sign-in'}"  variant="outline-primary" class="mr-2">Sign-in</b-button>
       <b-button :to="{name:'register'}"  variant="outline-primary" class="mr-2">Register</b-button>
       <b-button  type="submit"  variant="primary" class="mr-2">Password Reset</b-button>
        </b-form>
       </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        email: ''
      },
      show: true
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      // alert(JSON.stringify(this.form))
      this.$store.dispatch('auth/passwordResetRequest', this.form)
    }
  }
}
</script>
<style scoped>
</style>
